import ApplyDataBase from './ApplyDataBase';
export default ApplyDataBase;